import styled from 'styled-components/macro';
import { ellipsis } from 'polished';
import { Link } from 'react-router-dom';
import { TYPOGRAPHY } from 'styleguide';

const Title = styled(Link)`
  display: block;
  margin: 0 0 5px 0;
  color: #fff;
  ${TYPOGRAPHY.title}
  text-decoration: none;
  ${ellipsis('700px')}
`;

export default Title;
